export enum localStorageKeys {
  ACCESS_TOKEN = 'access_token'
}
